// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___2pjjv","text":"text___2AExy","size":"size___1FNGi"};